export default __webpack_public_path__ + "static/media/OpenSans-Medium.a4894b36.ttf";